// extracted by mini-css-extract-plugin
export default {"input":"AcademyModuleInput_input__VDdU-"};